import { gql } from "@apollo/client";

export default gql`
  mutation setMemberCareerRole(
    $organizationId: Int!
    $userId: Int!
    $roleId: Int
    $endRoleIds: [Int!]
  ) {
    setUserCareerRole(
      organizationId: $organizationId
      userId: $userId
      roleId: $roleId
      endRoleIds: $endRoleIds
    ) {
      ok
    }
  }
`;
